import { setFontSize } from "roosterjs-editor-api";
/**
 * Font size mapping configuration
 * Maps localized string keys to CSS font-size values
 */ const FONT_SIZE_MAP = {
    fontSizeLarge: "x-large",
    fontSizeMedium: "inherit",
    fontSizeSmall: "xx-small"
};
/**
 * Simple type guard to check if a key exists in our font size map
 */ function isCustomFontSizeKey(key) {
    return Object.prototype.hasOwnProperty.call(FONT_SIZE_MAP, key);
}
/**
 * "Font Size" button configuration for the format ribbon
 * Provides a dropdown menu with small, medium, and large font size options
 */ export const fontSizeButton = {
    key: "buttonNameFontSize",
    unlocalizedText: "Font size",
    iconName: "FontSize",
    dropDownMenu: {
        items: FONT_SIZE_MAP,
        getSelectedItemKey: (formatState)=>{
            if (formatState.fontSize) {
                // Find matching key by comparing values
                for (const [key, value] of Object.entries(FONT_SIZE_MAP)){
                    if (value === formatState.fontSize) {
                        return key;
                    }
                }
            }
            return "";
        }
    },
    onClick: (editor, sizeLabel)=>{
        if (isCustomFontSizeKey(sizeLabel)) {
            const fontSize = FONT_SIZE_MAP[sizeLabel];
            setFontSize(editor, fontSize);
        }
    }
};
